function closewin() {
    $('#window').attr('class','hhde');
    $('#window').html('');
}



// function number_format (number, decimals, dec_point, thousands_sep) {
   
//     number = (number + '').replace(',', '').replace(' ', '');
//     var n = !isFinite(+number) ? 0 : +number,
//         prec = !isFinite(+decimals) ? 0 : Math.abs(decimals),
//         sep = (typeof thousands_sep === 'undefined') ? ',' : thousands_sep,
//         dec = (typeof dec_point === 'undefined') ? '.' : dec_point,
//         s = '',
//         toFixedFix = function (n, prec) {
//             var k = Math.pow(10, prec);
//             return '' + Math.round(n * k) / k;
//         };
//     // Fix for IE parseFloat(0.55).toFixed(0) = 0;
//     s = (prec ? toFixedFix(n, prec) : '' + Math.round(n)).split('.');
//     if (s[0].length > 3) {
//         s[0] = s[0].replace(/\B(?=(?:\d{3})+(?!\d))/g, sep);
//     }
//     if ((s[1] || '').length < prec) {
//         s[1] = s[1] || '';
//         s[1] += new Array(prec - s[1].length + 1).join('0');
//     }
//     return s.join(dec);
// }
// function fotozamena(entry,id){
    
//     document.getElementById(id).src='/'+entry;
    
// }

 


// function savesum(kvo,ids) {
	
// var zapros="id="+ids+"&kvo="+kvo;
            
//     $.ajax({  
//           type: 'POST',
//           url: '.php',
//           data: zapros,
//           beforeSend: function() {},
//           success: function(data) {}
        
//         });            
// }



// function makesearch(entry)
// {
    
//     if(entry.length>2) {
        
//         var zapros="entry="+entry;
	
    
//     $.ajax({  
//           type: 'POST',
//           url: '/.php',
//           data: zapros,
//           beforeSend: function() {
//           },
          
//           success: function(data) {
        
            
//             document.getElementById('searchresults').innerHTML=data;
//             document.getElementById('searchresults').style.display='block';

            

            
            
//          }
        
//         });
    

        
//     } else{
//         document.getElementById('searchresults').innerHTML='';
//         document.getElementById('searchresults').style.display='none';
//     }
    
// }



// function addtocard(ids,lan,entry,page,tovarid) {

//     var kvo=1;
    
//     if(document.getElementById('kvo')) {
//         kvo = parseInt($('#kvo').text());
//     }
    
//     var zapros="id="+ids+"&kvo="+kvo;
    
//     if($("input[name=size]").is(":checked"))
//     {
        
//         zapros+='&sizes='+$("input[name=size]:checked").val();
        
//      $.ajax({  
//           type: 'POST',
//           url: '/.php',
//           data: zapros,
//           beforeSend: function() {
//           },
          
//           success: function(data) {
        
//             const obj = JSON.parse(data);
            
//             if(obj.status=='okay') {
                            
        
// document.getElementById('modas'+ids).innerHTML='<a href="/korzina" class="btn">Go to cart</a>';
// $('#hlopak span').text(obj.totale);

//             }

//             if(obj.status=='error') {
                
//     var paki='<div class="fl big">Error</div><div class="fr"><span class="close" onclick="closewin()"></span></div><div class="cl padd1" style="color:red">'+obj.answer+'</div>';
    
//     $('#window').html(paki);
//     $('#window').attr('class','hhdw');
//             }
            
//          }
        
//         });
      
        
//     } else {
        
// var paki='<div class="fl big">Notification</div><div class="fr"><span class="close" onclick="closewin()"></span></div><div class="cl padd1" style="color:red">Select size first please</div>';
    
//     $('#window').html(paki);
//     $('#window').attr('class','hhdw');        
        
//         }
	      
            
// }

 



function recalc(ids, amount) {
    
    if(ids>0) {
    ids = parseInt(ids);
    amount = parseInt(amount);
    
    var source = $('#source-'+ids).text();
    
    source = source.replace(/,/gi, '.');
    source = parseFloat(source);
    
    var istot = source*amount;
    
    var sota = number_format(istot,0,',','');
        
    $('#itog-'+ids).val(sota);
    }
    var sum = 0;
    //пересчитываем все позиции в корзине
    $("input[id^='itog-']").each(function(){
        ss = $(this).val();
        ss = ss.replace(/,/gi, '.');
        
        sum+=parseFloat(ss);
       
    });
    //sum = ;
    $('input.vsego').val(number_format(sum,0,',',''));
    
    
    
    
}

$(document).ready(function() {

 var dlina = $(window).width();
    var vysota = $(window).height();
     
    $(window).resize(function() {
          dlina = $(window).width();
          vysota = $(window).height();
          
          
    });

$(window).scroll(function(){if($(this).scrollTop()>300){
    $('#verh').fadeIn();
    if(dlina<450) {
        $('#nav').css({
           'position'   : 'fixed',
           'left'       : 0,
           'top'        : 0,
           'z-index'    : 100
        });
    }
                        }
    else {
        $('#verh').fadeOut();
        $('#nav').css({
           'position'   : 'relative',
           'left'       : 'auto',
           'top'        : 'auto',
           'z-index'    : 1
        });
        }});

$('input[name="delivery"]').change(function(){
    recalc(0,0);
});

// $('#sso').on('change','input[type="radio"]',function(){
    
//    var price = $(this).attr('data-id'); 
//    price = price.split('^^');
   
   
//     $('.prices .mainp').text(price[0]+' USD');
    
//     if(price[1]!='' && price[1]!=0) {
//         $('.prices span.old').text(price[1]+' USD');
//         $('.prices span.old').css('display','block');
//     }
//     else {
//         $('.prices span.old').text('');
//         $('.prices span.old').css('display','none');
//     }
    
//    $('#kvo').text('1'); 
// });

$('#showmore').click(function(){
   
   if($(this).attr('class')=='vniz') {
      $(this).attr('class','vverh');
      $(this).prev().css('height','auto');
   } else {
      $(this).attr('class','vniz');
      $(this).prev().css('height','105px');
   }
    
});

$(document).keydown(function(e) {
    
    if (e.keyCode == 27) {
        $('#window').attr('class','hhde');
        $('.search').html('');
    }
});


//скрываем выпадающие списки
$('body').click(function(e){
   
   if(e.target.className=='search' || e.target.tagName=='INPUT' && e.target.className=='pole') {return false;}
   else $('.search').html('');

});



//Insert search
$(document).ready(function () {
    // Клик по кнопке поиска
    $('.search').click(function () {
        // Если контейнер уже существует, не создаём новый
        if ($(this).find('.sps').length > 0) return;

        $(this).append(`
            <div class="sps">
                <input type="text" class="pole" placeholder="Search">
            </div>
            <div id="searchresults">
                <ul></ul>
            </div>
        `);
        $(this).find('input').focus();
    });

    // Функция для форматирования цены
    function formatMoney(amount) {
        let rounded = Math.round(amount);
        return rounded + ' USD';
    }

    // Обработчик поиска
    $(document).on('keyup', '.pole', function () {
        let query = $(this).val().trim();
        const $ul = $('#searchresults ul');

        if (query.length < 2) {
            $ul.empty();
            return;
        }

        $.getJSON(`/search/suggest.json?q=${encodeURIComponent(query)}&resources[type]=product&resources[limit]=5`, function (data) {
            let products = data.resources.results.products;
            let html = '';

            if (products.length > 0) {
                products.forEach(function (product) {
                    html += `
                        <li class="search-item">
                            <a href="${product.url}">
                                <img src="${product.image}" alt="${product.title}" width="50">
                                ${product.title} - ${formatMoney(product.price)}
                            </a>
                        </li>
                    `;
                });
            } else {
                html = '<li style="padding:10px;">No products found</li>';
            }

            $ul.html(html);
        });
    });
});

// $('#hlopak').click(function(){
   
//    var lana='';
//    if(lan=='ua') var lana='/ua';
   
//    location.href=lana+'/korzina';
    
// });

$('.addtocart').click(function(){
   
   var lnk = $(this).closest('.product').find('a.inzom').attr('href');
   location.href=lnk;
    
});


$('.totalnums input').blur(function(){
   
   var amount = $(this).val();
   var ids = $(this).parent().parent().attr('id');
   ids = ids.replace(/num-/gi, '');
   
   recalc(ids,amount);
    
});



// $('.minus').click(function(){
   
//    var prs = parseInt($(this).next().text());
//    prs--;
//    if(prs<1) prs=1;
//    $(this).next().text(prs);
    
// });
// $('.plus').click(function(){
   
//    var maxvalue=1000;
   
//    if(document.getElementById('sso')) {
    
//         if(parseInt($('#sso input[type="radio"]:checked').length)==0) {
            
//            var word1='First of all select size please'; 
            
//             var paki='<div class="fl big">Notification</div><div class="fr"><span class="close" onclick="closewin()"></span></div><div class="cl padd1" style="color:red">'+word1+'</div>';
//             $('#window').html(paki);
//             $('#window').attr('class','hhdw'); 
           
//         }
//         else {
            
//             //выбираем сколько этого размера в наличии
//             var maxvalue = parseInt($('#sso input[type="radio"]:checked').attr('data-label'));
            
//             var prs = parseInt($(this).prev().text());
//                prs++;
               
//                if(prs>maxvalue) prs=maxvalue;
               
//                $(this).prev().text(prs);
//         } 
    
//    }
   
   
    
// });

// $('.up').click(function(){
    
//     var ids = $(this).parent().attr('id');
//     ids = ids.replace(/num-/gi, '');
   
//    var prs = parseInt($(this).prev().find('input').val());
   
//    var maks = parseInt($(this).prev().find('input').attr('max'));
   
//    prs++;
//    if(prs>maks) prs=maks;
   
//    $(this).prev().find('input').val(prs);
   
//    savesum(prs,$(this).attr('data-label'));
   
//    recalc(ids,prs);
    
// });
// $('.down').click(function(){
   
//    var ids = $(this).parent().attr('id');
//     ids = ids.replace(/num-/gi, '');
   
//    var prs = parseInt($(this).next().find('input').val());
//    prs--;
//    if(prs<1) prs=1;
//    $(this).next().find('input').val(prs);
   
//    savesum(prs,$(this).attr('data-label'));
   
//    recalc(ids,prs);
    
// });


$('.panel').on('click','.pause',function(){
   document.getElementById('videos').pause();
    $('#playpause span').css('background-image','url(https://cdn.shopify.com/s/files/1/0706/5170/7566/files/play.png?v=1754916253)');
    $(this).attr('class','play');
    $('.logotype').fadeIn();
});
$('.panel').on('click','.play',function(){
   document.getElementById('videos').play();
    $('#playpause span').css('background-image','url(https://cdn.shopify.com/s/files/1/0706/5170/7566/files/pause.png?v=1754916241)');
    $(this).attr('class','pause');
    $('.logotype').fadeOut();
});

$('#verh').click(function(){$('body,html').animate({scrollTop:0},400);return false;});
    
  



$('.bars').click(function(){
   
   var wd = $(this).next().css('display');
   if(wd=='none') {
        $(this).css('background-image','url(https://cdn.shopify.com/s/files/1/0706/5170/7566/files/close1.png?v=1754922127)');
        $(this).next().fadeIn();
   } else {
        $(this).css('background-image','url(https://cdn.shopify.com/s/files/1/0706/5170/7566/files/bars.png?v=1754916070)');
        $(this).next().fadeOut();
   }
    
});



});   